/**
 * Adruino Newsletter
 * For modals HTML refer below snippets
 * - arduino-newsletter-privacy.liquid
 * - arduino-newsletter-thank-you.liquid
 * - arduino-newsletter-survey.liquid
*/

import Snackbar from 'node-snackbar';


(function() {
    const serviceUrl = 'https://api2.arduino.cc/consent/v1/subscription';
    
    let siteKey = '';

    const subscriptionData = {
        email: String(''),
        force: Boolean(false),
        country: String(''),
        marketing_approval: Boolean(false),
        newsletter_approval: Boolean(false),
        privacy_approval: Boolean(false),
        survey_tags: Array(),
        tags: Array(),
        tracking_approval: Boolean(false)
    };

    const translations = new Map();

    function t(key) {
        return translations.has(key) ? translations.get(key) : 'Missing translation for ' + key;
    }

    function loadTranslations() {
        const translationsElement = document.querySelector('[data-newsletter-translations]');
        const data = JSON.parse(translationsElement.innerHTML);

        for(let key in data) {
            translations.set(key, data[key]);
        }
    }

    function loadRecaptchaSiteKey() {
        const recaptchaElement = document.querySelector('[data-newsletter-recaptcha-sitekey]');
        const data = JSON.parse(recaptchaElement.innerHTML);

        siteKey = data['site_key'];
    }

    async function createSubscription(data) {
        const token = await grecaptcha.execute(siteKey, {action: 'submit'});

        return fetch(serviceUrl, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'X-Recaptcha-Token': token
            },
            body: JSON.stringify(data)
        });
    }

    function toggleModal(modalSelector) {
        const modal = document.querySelector(modalSelector);
        modal.classList.toggle('open');
    }

    function onEmailSubmit(event) {
        event.preventDefault();

        const form = event.target;

        const emailInput = form.querySelector('input[name="newsletter-email"]');
        const regExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

        resetErrorMessage('#ino-newsletter__error');

        if(emailInput.value && regExp.test(emailInput.value)) {
            subscriptionData.email = emailInput.value;
            toggleModal('#privacy-modal');
        } else {
            showErrorMessage('#ino-newsletter__error', t('invalid_email'));
        }
    }

    function resetErrorMessage(containerSelector) {
        const container = document.querySelector(containerSelector);

        container.innerHTML = '';
        container.classList.remove('ino-newsletter__error--visible');
    }

    function showErrorMessage(containerSelector, message) {
        const container = document.querySelector(containerSelector);

        container.innerHTML = message;
        container.classList.add('ino-newsletter__error--visible');
        container.focus();
    }

    function showSuccessMessage(message) {
        Snackbar.show({
            pos: 'bottom-center', 
            text: message, 
            actionTextColor: '#ffffff',
            backgroundColor: '#374146',
            showAction: false
        });
    }

    function onPrivacySubmit(event) {
        event.preventDefault();

        const inputs = event.target.elements;

        resetErrorMessage('#ino-newsletter__privacy-modal__error');

        for(let input of inputs) {
            if(input.name == 'newsletter_approval' && !input.checked) {
                showErrorMessage('#ino-newsletter__privacy-modal__error', t('privacy_policy'));
                return false;
            }

            subscriptionData[input.name] = input.checked;
        }

        subscriptionData.privacy_approval = true;

        onPrivacySubmitSuccess();
    }

    function onPrivacySubmitSuccess() {
        toggleModal('#privacy-modal');
        toggleModal('#thank-you-modal');
    }

    function onThankYouSubmit(event) {
        event.preventDefault();

        const inputs = event.target.elements;
        const tags = [];

        for(let input of inputs) {
            if(input.checked) {
                tags.push(input.name);
            }
        }

        subscriptionData.tags = tags;

        onThankYouSubmitSuccess();
    }

    function onThankYouSubmitSuccess() {
        toggleModal('#thank-you-modal');toggleModal('#survey-modal');
    }

    function onSurveySubmit(event) {
        event.preventDefault();

        const inputs = event.target.elements;
        const survey_tags = [];

        for(let input of inputs) {
            if(input.checked) {
                survey_tags.push(input.name);
            }

            if(input.name === 'country') {
                subscriptionData.country = input.value;
            }
        }

        subscriptionData.survey_tags = survey_tags;

        resetErrorMessage('#ino-newsletter__survey-modal__error');

        grecaptcha.ready(() => {
            createSubscription(subscriptionData).then((response) => {
                if(response.ok) {
                    onSurveySubmitSuccess();
                }
            }).catch((error) => {
                console.error(error);
                showErrorMessage('#ino-newsletter__survey-modal__error', t('survey_submit_error'));
            });
        });
    }

    function onSurveySkip(event) {
        event.preventDefault();

        subscriptionData.survey_tags = [];

        resetErrorMessage('#ino-newsletter__survey-modal__error');

        grecaptcha.ready(() => {
            createSubscription(subscriptionData).then((response) => {
                if(response.ok) {
                    onSurveySubmitSuccess();
                }
            }).catch((error) => {
                console.error(error);
                showErrorMessage('#ino-newsletter__survey-modal__error', t('survey_skip_error'));
            });
        });
    }

    function onSurveySubmitSuccess() {
        toggleModal('#survey-modal');
        showSuccessMessage(t('survey_submit_success'));
    }

    function init() {
        // add listeners for modal toggles
        const toggles = document.querySelectorAll('[data-modal-toggle]');

        for(let toggle of toggles) {
            toggle.addEventListener('click', (event) => {
                const modal = event.target.closest('.ino-modal__wrap');
                toggleModal('#' + modal.id);
            });
        }

        // load translations
        loadTranslations();

        // load recaptchas
        loadRecaptchaSiteKey();

        // add listeners for forms
        const emailForm = document.querySelector('[data-newsletter-email-form]');

        emailForm.classList.remove('hidden');
        emailForm.addEventListener('submit', onEmailSubmit);

        const privacyForm = document.querySelector('[data-newsletter-privacy-form]');
        privacyForm.addEventListener('submit', onPrivacySubmit);

        const thankYouForm = document.querySelector('[data-newsletter-thank-you-form]');
        thankYouForm.addEventListener('submit', onThankYouSubmit);

        const surveySubmitButton = document.querySelector('[data-newsletter-survey-form]');
        surveySubmitButton.addEventListener('submit', onSurveySubmit);

        const surveySkipButton = document.querySelector('[data-survey-skip]');
        surveySkipButton.addEventListener('click', onSurveySkip);
    }

    window.addEventListener('load', init);
})();